import apiService from './apiService';

const API_URL = '/Prospect';
/**/ 

const getProspects = async (filters, page, rowsPerPage) => {
  try {
    const params = {
      ...filters,
      page,
      pageSize: rowsPerPage,
    };
    
    console.log('Enviando solicitud de prospectos con parámetros:', JSON.stringify(params, null, 2));
    const response = await apiService.post(`${API_URL}/filtered`, params);
    console.log('Respuesta recibida de prospectos:', response);
    
    // Verificar que la respuesta tenga la estructura esperada
    if (!response) {
      console.error('No se recibió respuesta del servicio de prospectos');
      return { total: 0, prospects: [] };
    }
    
    return response;
  } catch (error) {
    console.error('Error detallado al obtener prospectos:', error);
    console.error('Error stack:', error.stack);
    if (error.response) {
      console.error('Error response status:', error.response.status);
      console.error('Error response data:', error.response.data);
    }
    throw error;
  }
};
const getAllProspects = async (filters) => {
  try {
    const params = {
      ...filters,
    };
    
    console.log('Enviando solicitud de todos los prospectos con parámetros:', params);
    const response = await apiService.post(`${API_URL}/all`, params);
    console.log('Respuesta recibida de todos los prospectos:', response);
    
    // Verificar que la respuesta tenga la estructura esperada
    if (!response) {
      console.error('No se recibió respuesta del servicio de todos los prospectos');
      return { total: 0, prospects: [] };
    }
    
    return response;
  } catch (error) {
    console.error('Error detallado al obtener todos los prospectos:', error);
    throw error;
  }
};
const getFilters = async () => {
  try {
    console.log('Llamando a API para obtener filtros...');
    const response = await apiService.get(`${API_URL}/filters`);
    console.log('Respuesta de API de filtros:', response);
    
    // Verificar que la respuesta tenga datos
    if (!response || !response.data) {
      console.error('La respuesta de filtros no contiene datos');
      return [];
    }
    
    // Asegurar que devolvemos un array
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Error detallado al obtener filtros:', error);
    if (error.response) {
      console.error('Error response status:', error.response.status);
      console.error('Error response data:', error.response.data);
    }
    return []; // Devolver array vacío en caso de error
  }
};

const prospectService = {
  getProspects,
  getAllProspects,
  getFilters
};

export default prospectService;